import { bool, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Skeleton from '../../../components/library/loaders/Skeleton';
import CollapsibleCardContent from '../../../components/library/stacking-collapsible-cards/CollapsibleCardContent';
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader';
import StackableCardWrapper from '../../../components/library/stacking-collapsible-cards/StackableCardWrapper';

const AssociatedReturnCard = props => {
    const { taxYear, loading, fileContext, associatedReturnId } = props

    var linkText = <HrbTranslate text='ReturnStatus.Card.AssociatedReturnLink' />
    var linkTo = '/filedreturn/' + associatedReturnId + '/year/' + taxYear
    var titleText = fileContext === 'PRIMARY' ? 'ReturnStatus.Card.AssociatedSpouseTitle' : 'ReturnStatus.Card.AssociatedPrimaryTitle'

    return (
        <StackableCardWrapper className='analyst-section'>
            <CollapsibleCardHeader>
                <div className='column is-1' />
                <div className='mt-2'>
                    {titleText === null || titleText === undefined ? <Skeleton /> :
                        <h5 className='return-status-title hnav-tabs'>
                            <HrbTranslate text={titleText} />
                        </h5>
                    }
                </div> 
            </CollapsibleCardHeader>
            <CollapsibleCardContent className='py-4 pb-5'>
                {loading && <Skeleton />}
                {!loading && associatedReturnId ?
                    associatedReturnId !== 'NotFiled' ? <Link to={linkTo} className="tile is-child"><div className="card-title-with-link-link">{linkText}</div></Link> : <HrbTranslate text='ReturnStatus.Card.NotFiled' /> :
                        <HrbTranslate text='ReturnStatus.Card.NotACoupledReturn' />
                }
            </CollapsibleCardContent>
        </StackableCardWrapper>
    )
}

    AssociatedReturnCard.propTypes = {
        lang: string,
        type: string,
        link: string,
        taxYear: string,
        client: string,
        loading: bool,
        fileContext: string
    }

export default AssociatedReturnCard;
